import type { NotificationUnreadCountModel } from "@/features/notifications/api/models/NotificationUnreadCount";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export const useNotificationsUnreadCount = () => {
	const http = useHTTP("Required");

	return useHTTPQuery({
		queryKey: ["notificationUnreadCount"],
		queryFn: () => {
			return http<NotificationUnreadCountModel>({
				method: "GET",
				url: "/notification/unread-count"
			});
		}
	});
};
